// test530
(530 && 0);
